import { Note } from './../Note';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HeaderService } from './header.service';
import { AuthService } from './auth.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NoteService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private headerService: HeaderService
  ) { }

  getNotes(account: string): Observable<Note[]> {
    const url = `${environment.rootApiUrl}/common/notes/${account}`;
    return this.http.get<Note[]>(url, this.headerService.getHttpOptionsXAuthHeaderFromCookie());
  }

  sendNote(passedParams: object) {
    const url = `${
      environment.rootApiUrl
      }/common/notes/sendnote`;

    let params = new HttpParams();
    params = params.append('payrollAccount', passedParams['payrollAccount']);
    params = params.append('note_cat', passedParams['note_cat']);
    params = params.append('note_type', passedParams['note_type']);
    params = params.append('note_case', passedParams['note_case']);
    params = params.append('note_detail', passedParams['note_detail']);

    return this.http.post(url, params, this.headerService.getHttpOptionsXAuthHeaderFromCookie());
  }

  getNoteCategory() {
    const url = `${
      environment.rootApiUrl
      }/common/notes/notecategory`;
    return this.http.get(url, this.headerService.getHttpOptionsXAuthHeaderFromCookie());
  }

}
